<style>
.el-tree-node__label {
  font-size: 12px;
}
</style>
<template>

  <div class="check-work-body">
    <div class="d-flex-right">
        <!-- 搜索框 -->
        <div class="search-wrap">
          <el-row>
            <el-col :span="24">
              <el-button size="mini" @click="edit(0)" type="warning" v-if="activeName == 'origin'">新增</el-button>
              <el-button size="mini" @click="handleNodeClick" type="primary">查询</el-button>
              <el-button size="mini" @click="clearSearch" type="primary">重置查询</el-button>
            </el-col>
          </el-row>
        </div>
        <!-- 搜索框 -->
        <div style="margin-bottom: 10px;">
          <el-descriptions :column="3" border size="mini">
            <el-descriptions-item label="年份">
              <el-date-picker v-model="keyword.year" type="year" value-format="yyyy" format="yyyy" placeholder="选择年"
                              @change="dateChange">
              </el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item label="月份">
              <el-date-picker v-model="keyword.month" type="month" value-format="M" format="M" placeholder="选择月">
              </el-date-picker>
            </el-descriptions-item>
            <el-descriptions-item label="姓名">
              <el-input size="mini" placeholder="" v-model="keyword.name" clearable></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="机构">
              <el-input size="mini" placeholder="" v-model="keyword.organization" clearable></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="项目">
              <el-input size="mini" placeholder="" v-model="keyword.project" clearable></el-input>
            </el-descriptions-item>
            <el-descriptions-item label="身份证">
              <el-input size="mini" placeholder="" v-model="keyword.identity_card" clearable></el-input>
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <!-- 操作框 -->
        <div class="search-wrap">
          <el-row style="width: 100%;">
            <el-col :span="6">
              <p style="color: #1e73e9">已审核人数：{{ statusTotal.pass_process_total }}</p>
              <p style="color: red">未审核人数：{{ statusTotal.not_process_total }}</p>
            </el-col>
            <el-col :span="18">
              <el-button size="mini" @click="submitFlow" type="danger">提交审核</el-button>
              <el-button size="mini" @click="importExcel('social_security_money')" type="success">导入社保</el-button>
              <el-button size="mini" @click="importExcel('housing_provident_fund')" type="success">导入公积金
              </el-button>
              <el-button size="mini" @click="importExcel('work_injury_insurance')" type="success">导入工伤险</el-button>
            </el-col>
          </el-row>
        </div>
      <div class="table-wrap">
        <el-table v-if="pageData" v-loading="loading" :data="pageData.list" height="600">
          <el-table-column fixed prop="name" label="姓名" align="center" width="" fixed></el-table-column>
          <el-table-column prop="organization" label="机构" align="center" width="150"></el-table-column>
          <el-table-column prop="project" label="项目" align="center" width="" fixed></el-table-column>
          <el-table-column prop="salary_year" label="发薪年份" align="center" width="50"></el-table-column>
          <el-table-column prop="salary_month" label="发薪月份" align="center" width="50"></el-table-column>
          <el-table-column prop="ought_to_attendance" label="应出勤" align="center"
                           width="50"></el-table-column>
          <el-table-column prop="practical_attendance" label="实际出勤" align="center"
                           width="50"></el-table-column>
          <el-table-column prop="salary_count_day" label="工资核算天数" align="center"
                           width="50"></el-table-column>
          <el-table-column prop="normal_salary" label="正常工作时间工资" align="center"
                           width=""></el-table-column>
          <el-table-column prop="fixed_overtime_salary" label="固定加班工资" align="center"
                           width=""></el-table-column>
          <el-table-column prop="perf_salary" label="绩效工资" align="center" width=""></el-table-column>
          <el-table-column prop="actual_attendance_salary" label="实际出勤工资" align="center"
                           width=""></el-table-column>
          <el-table-column prop="overtime_salary" label="加班费" align="center" width=""></el-table-column>
          <el-table-column prop="other_money" label="其他奖励" align="center"
                           width=""></el-table-column>
          <el-table-column prop="ought_to_salary" label="应发工资" align="center"
                           width=""></el-table-column>
          <el-table-column prop="housing_provident_fund" label="住房公积金" align="center"
                           width=""></el-table-column>
          <el-table-column prop="agent_subtract_money_total" label="代理扣除金额" align="center"
                           width=""></el-table-column>
          <el-table-column prop="social_security_money" label="社保费" align="center"
                           width=""></el-table-column>
          <el-table-column prop="housing_provident_fund" label="公积金" align="center"
                           width=""></el-table-column>
          <el-table-column prop="work_injury_insurance" label="工伤险" align="center"
                           width=""></el-table-column>
          <el-table-column prop="personal_income_tax" label="个人税" align="center"
                           width=""></el-table-column>
          <el-table-column prop="other_subtract_money" label="其他扣款" align="center"
                           width=""></el-table-column>
          <el-table-column prop="actual_salary" label="实发工资" align="center" width=""></el-table-column>
          <el-table-column prop="check_status" label="审批状态" align="center" width="">
            <template slot-scope="scope">
              <span v-if="scope.row.check_status == 0">待审核</span>
              <span v-if="scope.row.check_status == 1">审核通过</span>
              <span v-if="scope.row.check_status == 2">审批中（走流程单）</span>
              <span v-if="scope.row.check_status == 100">审核失败</span>
              <span v-if="scope.row.check_status == 101">审批失败</span>
              <span v-if="scope.row.check_status == 1000">完成</span>
            </template>
          </el-table-column>
          <el-table-column prop="edit_type" label="信息来源" align="center" width="">
            <template slot-scope="scope">
              <span v-if="scope.row.edit_type == 1">小程序</span>
              <span v-if="scope.row.edit_type == 2">后台</span>
            </template>
          </el-table-column>
          <el-table-column prop="remark" label="备注" align="center" width=""></el-table-column>
          <el-table-column prop="" label="是否已导社保" align="center" width="">
            <template slot-scope="scope">
              <span v-if="scope.row.is_import_social_security_money == 0" style="color: #F56C6C">否</span>
              <span v-if="scope.row.is_import_social_security_money == 1" style="color: #409EFF">是</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="是否已导公积金" align="center" width="">
            <template slot-scope="scope">
              <span v-if="scope.row.is_import_housing_provident_fund == 0" style="color: #F56C6C">否</span>
              <span v-if="scope.row.is_import_housing_provident_fund == 1" style="color: #409EFF">是</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="是否已导工伤险" align="center" width="">
            <template slot-scope="scope">
              <span v-if="scope.row.is_import_work_injury_insurance == 0" style="color: #F56C6C">否</span>
              <span v-if="scope.row.is_import_work_injury_insurance == 1" style="color: #409EFF">是</span>
            </template>
          </el-table-column>
          <el-table-column prop="operation" label="操作" width="160">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="edit(scope)">修改</el-button>
              <el-button type="danger" size="mini" @click="delAdminOrigin(scope)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div>
        <!-- 分页 -->
        <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total=pageData.total
                         :page-size="pageData.pageSize * 1" :current-page="pageData.page * 1"
                         @current-change="pageChange"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 修改窗口 -->
    <el-dialog title="编辑" z-index="990" :visible.sync="dialogVisible" :close-on-click-modal="false" width="1000px">
      <div style="max-height: 700px;overflow-y: auto;">
        <el-descriptions class="margin-top" title="" :column="2" size="mini" border>
          <el-descriptions-item label="姓名">
            <el-select v-model="update_form.name" filterable remote :remote-method="getUserInfoCollect"
                       placeholder="请输入姓名或身份证号码" :loading="loading" @change="selectUserChange"
                       :disabled="add_type == 'edit'">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="发薪年份">
            <el-date-picker v-model="update_form.salary_year" value-format="yyyy" format="yyyy" type="year"
                            placeholder="选择年"
                            :disabled="add_type == 'edit'">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="发薪月份">
            <el-date-picker v-model="update_form.salary_month" :disabled="add_type == 'edit'" type="month"
                            value-format="M" format="M" placeholder="选择月">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="应出勤">
            <el-input size="mini" class="form-input" v-model="update_form.ought_to_attendance"
                      autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="实际出勤">
            <el-input size="mini" class="form-input" v-model="update_form.practical_attendance"
                      autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="">
          </el-descriptions-item>
          <el-descriptions-item label="其他奖励金额">
            <el-input size="mini" class="form-input" v-model="update_form.other_money"
                      autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="其他扣减金额">
            <el-input size="mini" class="form-input" v-model="update_form.other_subtract_money"
                      autocomplete="off"></el-input>
          </el-descriptions-item>
          <el-descriptions-item label="备注">
            <el-input type="textarea" placeholder="请输入内容" v-model="update_form.remark" maxlength="100"
                      show-word-limit>
            </el-input>
          </el-descriptions-item>

        </el-descriptions>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogVisible = false">关 闭</el-button>
        <el-button size="mini" @click="save_form()">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import Http from "./common/Http";

export default {
  name: "PreSalaryOrigin",
  data() {
    return {
      data: [],
      host_url: "",
      keyword: {
        name: "",
        year: "",
        month: "",
      },
      loading: false,
      where: {
        //搜索框
        name: "",
        phone: "",
        department: "",
        //
        meter_type: "",
        house_name: "",
        number: "",
        charging_standard: "",
        status: "",
        status_ids: [1, 0],
        line: "",
        meter_nature: "",
        meter_nature_ids: [1, 2, 3, 4],
        note_type: "",
        is_accident: "",
        is_examine: "",
        is_examine_ids: [1, 0],
      },
      pageData: {
        list: [],
        total: 0,
        pageSize: 10,
        page: 1
      },
      dialogVisible: false,
      treeDialogVisible: false,
      generateVisible: false,
      statusTotal: {
        pass_process_total: 0,
        not_process_total: 0,
      },
      // form: {},
      form: {
        name: '',
        salary_year: "",
        salary_month: "",
        normal_salary: "",
        fixed_overtime_salary: "",
        perf_salary: "",
        comprehensive_sum_salary: "",
        actual_attendance_salary: "",
        overtime_salary: "",
        housing_provident_fund: "",
        agent_subtract_money_total: "",
        personal_income_tax: '',
        actual_salary: "",
        remark: "",
        this_month_change: "",
        ought_to_attendance: "",
        practical_attendance: "",
        salary_count_day: "",
        temperature_money: "",
        festival_money: "",
        internship_money: "",
        other_money: "",
        social_security_money: "",
        water_money: "",
        electricity_money: "",
        other_subtract_money: "",
      },
      update_form: {
        name: '',
        salary_year: "",
        salary_month: "",
        normal_salary: "",
        fixed_overtime_salary: "",
        perf_salary: "",
        comprehensive_sum_salary: "",
        actual_attendance_salary: "",
        overtime_salary: "",
        housing_provident_fund: "",
        agent_subtract_money_total: "",
        personal_income_tax: '',
        actual_salary: "",
        remark: "",
        this_month_change: "",
        ought_to_attendance: "",
        practical_attendance: "",
        salary_count_day: "",
        temperature_money: "",
        festival_money: "",
        internship_money: "",
        other_money: "",
        social_security_money: "",
        water_money: "",
        electricity_money: "",
        other_subtract_money: "",
      },
      uploadUrl: "",
      month_value: "",
      business_list: [],
      entry_type_name: "",

      charging_standard: "",
      activeName: "origin",
      nodeLevel: '',
      department_id: "",
      options: [],
      add_type: ""
    }
  },
  // 获取列表
  mounted() {
    // this._initKeyword()
    var params = {
      activeName: this.activeName
    }
    this.getPreUserList(params);


  },
  methods: {
    _initKeyword() {
      //初始化年月(获取当前的)
      var date = new Date();
      let year = date.getFullYear()
      let month = date.getMonth()
      this.keyword.year = year.toString()
      this.keyword.month = month.toString()
    },
    selectUserChange(item) {
      this.update_form.user_id = item;
    },
    getUserInfoCollect(query) {

      if (query) {
        Http.get(Http.getPreBaseURL() + "/oa/PreUserInfo/getUserInfoCollect", {
          keyword: query
        }, res => {
          if (res.code === 0) {
            this.options = res.data;
          } else {
            this.$message.error({
              message: res.msg,
              type: "error",
            });
          }
        })
      }


    },
    onSelChange(value) {
      this.update_form.this_month_change = value;
    },
    // importExcel() {
    //   var that = this;
    //
    //   CommonHelp.uploadSalaryFile(ret => {
    //     that.$message({
    //       message: '导入成功',
    //       type: 'success'
    //     });
    //     that.getPreUserList()
    //   });
    // },
    exportSalary() {
      var params = {
        //department_id: department_id,
        name: this.keyword.name,
        year: this.keyword.year,
        month: this.keyword.month,
        page: this.pageData.page,
        page_size: this.pageData.page_size,
        activeName: this.activeName,
        organization: this.keyword.organization,
        project: this.keyword.project,
        identity_card: this.keyword.identity_card
      }
      if (params.year === '' || params.month === '') {
        this.$message({
          message: '请输入年份和月份才能导出记录',
          type: 'error'
        });
        return false;
      }
      Http.get(Http.getPreBaseURL() + "/oa/PreUserSalary/exportSalary", params, res => {
        if (res) {
          window.open(Http.getPreBaseURL() + res.data)
          this.$message({
            message: '导出成功',
            type: 'success'
          });
        } else {
          this.$message.error({
            message: '导出失败',
            type: "error",
          });
        }
      })
    },
    exportOriginSalary() {
      var params = {

        name: this.keyword.name,
        year: this.keyword.year,
        month: this.keyword.month,
        page: this.pageData.page,
        page_size: this.pageData.page_size,
        activeName: this.activeName,
        organization: this.keyword.organization,
        project: this.keyword.project,
        identity_card: this.keyword.identity_card
      }
      if (params.year === '' || params.month === '') {
        this.$message({
          message: '请输入年份和月份才能导出记录',
          type: 'error'
        });
        return false;
      }
      Http.get(Http.getPreBaseURL() + "/oa/PreUserSalary/exportOriginSalary", params, res => {
        if (res) {
          window.open(Http.getPreBaseURL() + res.data)
          this.$message({
            message: '导出成功',
            type: 'success'
          });
        } else {
          this.$message.error({
            message: '导出失败',
            type: "error",
          });
        }
      })
    },
    clearSearch() {
      this.keyword = {}
    },
    handleTabClick(tab) {
      this.activeName = tab.name;

      if (this.activeName == 'audit') {
        return this.$router.push({
          path: '/flow/FlowProcessSteps',
          query: {}
        });
      }
      this.keyword = {}
      // this._initKeyword()
      var params = {
        department_id: this.department_id,
        name: '',
        year: this.keyword.year,
        month: this.keyword.month,
        page: 1,
        page_size: 10,
        activeName: this.activeName,
        organization: '',
        project: '',
        identity_card: '',
        level: this.nodeLevel ? this.nodeLevel : ''

      }
      this.getPreUserList(params);
    },

    // 提交审核
    submitFlow() {
      // 判断是否全部已审核通过
      if (this.statusTotal.not_process_total > 0) {
        this.$message.error({
          message: "还有员工未通过审核",
          type: "error",
        });
        return false
      }

      let params = {
        name: this.keyword.name,
        year: this.keyword.year,
        month: this.keyword.month,
        activeName: this.activeName,
        organization: this.keyword.organization,
        project: this.keyword.project,
        identity_card: this.keyword.identity_card
      }
      let resData = [];
      let that = this
      Http.get(Http.getPreBaseURL() + "/oa/PreUserSalary/submitFlow", params, res => {
        if (res.code == 0) {
          resData = res.data
          // 跳转到流程审批
          that.$router.push({
            path: '/flow/FlowView',
            query: {
              'sheet_id': 40,
              'master_id': 38,
              'timeValue': Date.now(),
              'file_title': resData.title,
              'file_local': resData.local,
              'base_url': 'http://api.gdzawy.com:9000',
            }
          });
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })


    },

    //pre工资列表
    getPreUserList(params) {
      //读取tabs数据
      Http.get(Http.getPreBaseURL() + "/oa/PreUserSalary/getSalaryList", params, res => {
        if (res.code === 0) {
          this.pageData.list = res.data.list.data;
          this.pageData.total = res.data.list.total;
          this.statusTotal = res.data.status_total;
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },

    //单选部门list
    checkedGetList(params, url) {
      Http.get(Http.getFlowBaseURL() + "/hr/department/getHuaRuiDepartmentList", {
        parent_id: params,
      }, res => {
        if (res.code === 0) {
          this.data = res.data;
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },

    //分页--选中页码
    pageChange(i) {
      this.pageData.page = i;
      this.pageData.page_size = 10;
      this.handleNodeClick();
    },

    //点击树形节点+搜索  = 输出表格
    handleNodeClick(data) {
      var page = ''
      var level = ''
      page = this.pageData.page
      if (data) {
        this.department_id = data.id
        level = data.level
        this.nodeLevel = data.level
        page = 1
      } else {
        level = ''
        page = this.pageData.page
      }
      var params = {
        department_id: this.department_id,
        name: this.keyword.name,
        year: this.keyword.year,
        month: this.keyword.month,
        page: page,
        page_size: this.pageData.page_size,
        activeName: this.activeName,
        organization: this.keyword.organization,
        project: this.keyword.project,
        identity_card: this.keyword.identity_card,
        // level:level
        level: level
      }
      this.getPreUserList(params);
    },

    //删除
    delAdminOrigin(item) {
      this.$confirm('是否确定删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Http.post(Http.getPreBaseURL() + "/oa/PreUserSalary/delAdminOrigin", {id: item.row.id},
          res => {
            if (res.code === 0) {
              // this.dialogVisible = false;
              this.$message({
                type: 'success',
                message: '删除成功!'
              });
              // this.getPreUserList();
            } else {
              this.$message.error({
                message: res.msg,
                type: "error",
              });
            }
          })
      }).catch(() => {
      });
    },
    //点击编辑按钮
    edit(item) {
      if (item == 0) {
        var id = 0;
        var null_form = {
          user_id: '',
          name: "",
          identity_card: "",
          salary_month: "",
          salary_year: "",
          ought_to_attendance: "",
          practical_attendance: "",
          salary_count_day: "",
          remark: ""
        }
        this.update_form = null_form;
        this.add_type = 'add'
      } else {
        var id = item.row.id;
        this.getOriginSalary(item.row.id);
        this.add_type = 'edit'
      }
      this.dialogVisible = true;
    },
    //获取某个工资记录
    getOriginSalary(id) {
      Http.get(Http.getPreBaseURL() + "/oa/PreUserSalary/getOriginSalaryById", {
        id: id,
      }, res => {
        if (res.code === 0) {
          this.update_form = res.data;
          this.update_form.salary_year = res.data.salary_year
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },
    //点击修改表单提交
    save_form() {
      var params = {
        department_id: this.department_id,
        name: this.keyword.name,
        year: this.keyword.year,
        month: this.keyword.month,
        page: this.pageData.page,
        page_size: this.pageData.page_size,
        activeName: this.activeName,
        organization: this.keyword.organization,
        project: this.keyword.project,
        identity_card: this.keyword.identity_card,
      }
      Http.post(Http.getPreBaseURL() + "/oa/PreUserSalary/adminAddOriginSalary", this.update_form,
        res => {
          if (res.code === 0) {

            this.dialogVisible = false;
            this.$message({
              message: res.msg,
              type: 'success'
            });
            this.getPreUserList(params);
          } else {
            this.$message.error({
              message: res.msg,
              type: "error",
            });
          }
        })
    },
    //获取个人信息
    getUserInfo(params) {
      Http.get(Http.getPreBaseURL() + "/oa/PreUserInfo/getUserInfoById", {
        id: params,
      }, res => {
        if (res.code === 0) {
          this.form = res.data;
        } else {
          this.$message.error({
            message: res.msg,
            type: "error",
          });
        }
      })
    },

    //节点下面的数据
    getData(node, resolve) {
      var region_id = node.data.id;//选中节点id
      var _this = this;
      setTimeout(() => {
        //节点不能为空
        if (region_id == '' || region_id == undefined) {
          return false;
        }
        //加载
        node.data.region_id = region_id;
        node.data && Http.get(Http.getFlowBaseURL() + '/hr/department/getHuaRuiDepartmentList', {parent_id: node.data.id,}, backdata => { // 异步执行成功后
          return resolve(backdata.data);
        });
      }, 300);
    },

    ////////////////////////////////////////////////////////重构后的代码////////////////////////////////////////////////////////////////

    // 导入execl
    importExcel(type) {
      let that = this;
      let upload = document.getElementById("uploadFile-9999");
      if (!upload) {
        upload = document.createElement('input');
        upload.type = "file";
        upload.id = "uploadFile-9999";
        upload.style.display = "none";
      }
      upload.click();
      upload.onchange = function (e) {
        let formData = new FormData();
        formData.append("file", this.files[0]);
        formData.append("type", type);
        Http.post(Http.getPreBaseURL() + '/oa/PreUserSalary/importExecl', formData, res => {
          that.$message({type: res.code === 0 ? 'success' : 'error', message: res.msg})
        })
        upload.onchange = undefined;
      }
    },

  }
}

function reObject(item) {
  return JSON.parse(JSON.stringify(item));
}
</script>
<style lang="scss" scoped>
.el-button--primary,
.el-button--danger,
.el-button--success,
.el-button--warning {
  color: #fff;
}

.el-tree-node__label {
  font-size: 12px;
}

.check-work-body {
  padding-left: 15px;
  padding-right: 15px;
  width: 98%;
}

.search-wrap {
  padding-bottom: 15px;
  border-bottom: 1px solid #EBEEF5;
}
.pagination-wrap {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}


.check-work-tb {
  border-collapse: collapse;

  td,
  th {
    border: 1px solid #EBEEF5;
    line-height: 20px;
    padding: 10px 10px;
    font-size: 12px;
  }

  th {
    font-weight: bold;
    text-align: left;
  }
}

.el-calendar-table .el-calendar-day {
  height: 50px;
}

.check-work-class-editor {
  margin-top: 10px;
  width: 100%;

  .cw-header {
    width: 100%;
    display: table;
    border-collapse: collapse;

    .cw-title {
      display: table-cell;
      border: 1px solid #EBEEF5;
      padding: 5px 10px;
      line-height: 20px;
      font-weight: bold;

      &.cw-name {
        width: 100px;
      }

      &.cw-class {
        flex: 1;
      }
    }

  }

}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  //flex: 1;
}

.form-input {
  width: 100%;
}

.table-wrap {
  width: 100%;
}

.amap-box {
  width: 500px;
  height: 500px;
}

.el-tree-1 {

  overflow-y: scroll;
  height: calc(100vh - 120px);
  width: 100%;
}


.fangtai-name {
  font-size: 12px;
}

.tree-wrap {
  width: 250px;
}

.project-selector {
  margin-bottom: 10px;
  display: flex;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Oa/PreSalaryOrigin.vue